import {
  IMetaData,
  LibraryMetadataType,
  LocationMetadataType,
  ObjectMap,
  PlayerMetadataType,
} from './interfaces'
import { convertEnvForPayload, mapMetadata } from '../utils'
import ActiveConfig from './activeConfig'
import PsmBridge from './psm-bridge'

class PsmMetadata<T> implements IMetaData<T> {
  brand: string
  subBrand: string
  platform: string
  environment: string
  schemaVersionNumber: string
  wmukid: string
  sessionId: string
  productName: string
  networkConnectionType: string
  appVersion: string
  playerVersion: string
  deviceSpecificMetadata: T
  playerDependencies: any

  constructor(playerDependencies: any) {
    this.initWMUKID()
    this.playerDependencies = playerDependencies
    const { brand, subBrand, platform, psmEnvironment, productName } = PsmBridge.psm.getConfig()
    this.brand = brand || null
    this.subBrand = subBrand || null
    this.platform = platform || null
    this.environment = convertEnvForPayload(psmEnvironment) || null
    this.schemaVersionNumber = ActiveConfig.currentVersion
    this.sessionId = PsmBridge.psm.getSessionProperties()?.sessionid
    this.productName = productName || this.subBrand
    this.networkConnectionType = PsmBridge.dependencies.networkConnectionType
    this.setRootLevelProperties(this.setLibraryProperties)
    this.setRootLevelProperties(this.setLocationProperties)
    this.setRootLevelProperties(this.setPlayerProperties.bind(this))
  }

  mappingMetadata(unmapped: ObjectMap, keyMap: ObjectMap, playerDependencies: any): ObjectMap {
    const playerSelected = keyMap.players.find(player => {
      return player.playerName === playerDependencies.playerVendor
    })
    const mappedMetadata = mapMetadata(unmapped, playerSelected.map)
    return mappedMetadata
  }

  initWMUKID(): void {
    function updateWMUKID(value: string) {
      this.wmukid = value
    }

    PsmBridge.dependencies.getWMUKID(updateWMUKID.bind(this))
  }

  setRootLevelProperties(setProperties: Function): void {
    Object.assign(this, setProperties())
  }

  setLocationProperties(): LocationMetadataType {
    const locations = PsmBridge.psm.getLocationProperties();
    return {
      city: locations?.city || null,
      state: locations?.state || null,
      country: locations?.country || null,
      timezone: locations?.timezone || null,
    };
  }

  setLibraryProperties(): LibraryMetadataType {
    const libraryProps = PsmBridge.psm.getLibrary();
    return {
      psmSdkName: libraryProps?.name.replace(' ', '') || null,
      psmSdkVersion: libraryProps?.version || null,
    };
  }

  setPlayerProperties(): Pick<PlayerMetadataType, 'playerVendor'> {
    return {
      playerVendor: this.playerDependencies.playerVendor
    };
  }
}

export default PsmMetadata
